import React from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { PrimeIcons } from 'primereact/api';
import { AutoComplete } from 'primereact/autocomplete';
import { classNames } from 'primereact/utils';
import { FormField } from '../../../components/FormField/FormField';
import { AdaptiveColorPicker } from '../../../components/AdaptiveColorPicker/AdaptiveColorPicker';
import { BranchSettingsFormState } from '../hooks/useBranchSettingsForm';
import { CityOption } from '../utils/searchCity';

interface Props {
  branchSettings: BranchSettingsFormState;
  organizationLoading: boolean;
  userHasEditFeature: boolean;
  orgHasAnySignedDocumentsFeature: boolean;
}

export const BranchSettingsSection = ({
  branchSettings,
  organizationLoading,
  userHasEditFeature,
  orgHasAnySignedDocumentsFeature,
}: Props) => {
  return (
    <form
      className={classNames({
        'form-loading': organizationLoading || branchSettings.isSaving,
      })}
      onSubmit={branchSettings.handleSave}
      ref={branchSettings.formRef}
    >
      <FormField fullWidth>
        <h4 className='branch-settings-title'>Datos de la sucursal</h4>
      </FormField>
      <FormField
        labelTitle='Nombre'
        elementId='branch-name'
        required
        error={branchSettings.validationErrors?.name}
        infoTooltip='Es el nombre con el que se mostrará la sucursal, tanto en el panel de control como en las aplicaciones externas.'
      >
        <InputText
          id='branch-name'
          placeholder='Ej: Sucursal Alameda'
          value={branchSettings.form?.name}
          onChange={(e) => branchSettings.setFormFields({ name: e.target.value })}
          invalid={!!branchSettings.validationErrors?.name}
        />
      </FormField>
      <FormField
        labelTitle='Color de la sucursal'
        elementId='branch-color'
        infoTooltip='Elige un color para identificar esta sucursal en el calendario de reservas.'
      >
        <div className='branch-color-picker-field'>
          <AdaptiveColorPicker
            id='branch-color'
            value={branchSettings.form?.color ?? '#000000'}
            onChange={(color) => branchSettings.setFormFields({ color })}
            disabled={!userHasEditFeature}
          />
          <span className='branch-color-label'>{branchSettings.form?.color ?? '#000000'}</span>
        </div>
      </FormField>
      {orgHasAnySignedDocumentsFeature && (
        <FormField
          labelTitle='Ciudad'
          elementId='branch-signed-documents-location'
          required
          error={branchSettings.validationErrors?.city}
          infoTooltip='La ciudad de la sucursal se usará para autocompletar documentos firmados.'
        >
          <AutoComplete
            id='branch-signed-documents-location'
            placeholder='Ej: Málaga'
            value={branchSettings.form?.city}
            onChange={(e) => branchSettings.setFormFields({ city: e.value?.name || e.value })}
            invalid={!!branchSettings.validationErrors?.city}
            suggestions={branchSettings.cities}
            completeMethod={branchSettings.handleCitySearch}
            field='name'
            forceSelection
            itemTemplate={(item: CityOption) => (
              <div className='city-item'>
                <span>{item.fullName}</span>
              </div>
            )}
          />
        </FormField>
      )}
      {userHasEditFeature && (
        <Button
          type='submit'
          disabled={!branchSettings.hasChanged}
          className='pull-right pull-down'
          label='Guardar'
          icon={PrimeIcons.SAVE}
        />
      )}
    </form>
  );
};
